import { Model } from '@singularsystems/neo-core';

export default class FileDescriptor extends Model.FileDescriptorBase {

    constructor() {
        super();
        this.makeObservable();
    }

    public audit: Model.AuditValues | null = new Model.AuditValues();

    // Client only properties / methods

    public toString(): string {
        if (this.isNew) {
            return "New file descriptor";
        } else {
            return "File Descriptor";
        }
    }
}